/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "cora",
        "0": "źinsa",
        "1": "witśe",
        "future": {
          "few": "za {0} dny",
          "one": "za {0} źeń",
          "other": "za {0} dnjow",
          "two": "za {0} dnja"
        },
        "past": {
          "few": "pśed {0} dnjami",
          "one": "pśed {0} dnjom",
          "other": "pśed {0} dnjami",
          "two": "pśed {0} dnjoma"
        }
      },
      "day-narrow": {
        "-1": "cr.",
        "0": "źis.",
        "1": "wit.",
        "future": {
          "few": "za {0} ź",
          "one": "za {0} ź",
          "other": "za {0} ź",
          "two": "za {0} ź"
        },
        "past": {
          "few": "pśed {0} d",
          "one": "pśed {0} d",
          "other": "pśed {0} d",
          "two": "pśed {0} d"
        }
      },
      "day-short": {
        "-1": "cra.",
        "0": "źins.",
        "1": "witś.",
        "future": {
          "few": "za {0} dny",
          "one": "za {0} źeń",
          "other": "za {0} dnj.",
          "two": "za {0} dnj."
        },
        "past": {
          "few": "pśed {0} dnj.",
          "one": "pśed {0} dnj.",
          "other": "pśed {0} dnj.",
          "two": "pśed {0} dnj."
        }
      },
      "hour": {
        "0": "w toś tej góźinje",
        "future": {
          "few": "za {0} góźiny",
          "one": "za {0} góźinu",
          "other": "za {0} góźin",
          "two": "za {0} góźinje"
        },
        "past": {
          "few": "pśed {0} góźinami",
          "one": "pśed {0} góźinu",
          "other": "pśed {0} góźinami",
          "two": "pśed {0} góźinoma"
        }
      },
      "hour-narrow": {
        "0": "w toś tej góźinje",
        "future": {
          "few": "za {0} g",
          "one": "za {0} g",
          "other": "za {0} g",
          "two": "za {0} g"
        },
        "past": {
          "few": "pśed {0} g",
          "one": "pśed {0} g",
          "other": "pśed {0} g",
          "two": "pśed {0} g"
        }
      },
      "hour-short": {
        "0": "w toś tej góźinje",
        "future": {
          "few": "za {0} góź.",
          "one": "za {0} góź.",
          "other": "za {0} góź.",
          "two": "za {0} góź."
        },
        "past": {
          "few": "pśed {0} góź.",
          "one": "pśed {0} góź.",
          "other": "pśed {0} góź.",
          "two": "pśed {0} góź."
        }
      },
      "minute": {
        "0": "w toś tej minuśe",
        "future": {
          "few": "za {0} minuty",
          "one": "za {0} minutu",
          "other": "za {0} minutow",
          "two": "za {0} minuśe"
        },
        "past": {
          "few": "pśed {0} minutami",
          "one": "pśed {0} minutu",
          "other": "pśed {0} minutami",
          "two": "pśed {0} minutoma"
        }
      },
      "minute-narrow": {
        "0": "w toś tej minuśe",
        "future": {
          "few": "za {0} m",
          "one": "za {0} m",
          "other": "za {0} m",
          "two": "za {0} m"
        },
        "past": {
          "few": "pśed {0} m",
          "one": "pśed {0} m",
          "other": "pśed {0} m",
          "two": "pśed {0} m"
        }
      },
      "minute-short": {
        "0": "w toś tej minuśe",
        "future": {
          "few": "za {0} min.",
          "one": "za {0} min.",
          "other": "za {0} min.",
          "two": "za {0} min."
        },
        "past": {
          "few": "pśed {0} min.",
          "one": "pśed {0} min.",
          "other": "pśed {0} min.",
          "two": "pśed {0} min."
        }
      },
      "month": {
        "-1": "zajźony mjasec",
        "0": "ten mjasec",
        "1": "pśiducy mjasec",
        "future": {
          "few": "za {0} mjasecy",
          "one": "za {0} mjasec",
          "other": "za {0} mjasecow",
          "two": "za {0} mjaseca"
        },
        "past": {
          "few": "pśed {0} mjasecami",
          "one": "pśed {0} mjasecom",
          "other": "pśed {0} mjasecami",
          "two": "pśed {0} mjasecoma"
        }
      },
      "month-narrow": {
        "-1": "zajź. mjasec",
        "0": "te. mjasec",
        "1": "pśid. mjasec",
        "future": {
          "few": "za {0} mjas.",
          "one": "za {0} mjas.",
          "other": "za {0} mjas.",
          "two": "za {0} mjas."
        },
        "past": {
          "few": "pśed {0} mjas.",
          "one": "pśed {0} mjas.",
          "other": "pśed {0} mjas.",
          "two": "pśed {0} mjas."
        }
      },
      "month-short": {
        "-1": "zajź. mjasec",
        "0": "tot. mjasec",
        "1": "pśiduc. mjasec",
        "future": {
          "few": "za {0} mjas.",
          "one": "za {0} mjas.",
          "other": "za {0} mjas.",
          "two": "za {0} mjas."
        },
        "past": {
          "few": "pśed {0} mjas.",
          "one": "pśed {0} mjas.",
          "other": "pśed {0} mjas.",
          "two": "pśed {0} mjas."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "zajźony kwartal",
        "0": "toś ten kwartal",
        "1": "pśiducy kwartal",
        "future": {
          "few": "za {0} kwartale",
          "one": "za {0} kwartal",
          "other": "za {0} kwartalow",
          "two": "za {0} kwartala"
        },
        "past": {
          "few": "pśed {0} kwartalami",
          "one": "pśed {0} kwartalom",
          "other": "pśed {0} kwartalami",
          "two": "pśed {0} kwartaloma"
        }
      },
      "quarter-narrow": {
        "-1": "zajźony kwartal",
        "0": "toś ten kwartal",
        "1": "pśiducy kwartal",
        "future": {
          "few": "za {0} kw.",
          "one": "za {0} kw.",
          "other": "za {0} kw.",
          "two": "za {0} kw."
        },
        "past": {
          "few": "pśed {0} kw.",
          "one": "pśed {0} kw.",
          "other": "pśed {0} kw.",
          "two": "pśed {0} kw."
        }
      },
      "quarter-short": {
        "-1": "zajźony kwartal",
        "0": "toś ten kwartal",
        "1": "pśiducy kwartal",
        "future": {
          "few": "za {0} kwart.",
          "one": "za {0} kwart.",
          "other": "za {0} kwart.",
          "two": "za {0} kwart."
        },
        "past": {
          "few": "pśed {0} kwart.",
          "one": "pśed {0} kwart.",
          "other": "pśed {0} kwart.",
          "two": "pśed {0} kwart."
        }
      },
      "second": {
        "0": "něnto",
        "future": {
          "few": "za {0} sekundy",
          "one": "za {0} sekundu",
          "other": "za {0} sekundow",
          "two": "za {0} sekunźe"
        },
        "past": {
          "few": "pśed {0} sekundami",
          "one": "pśed {0} sekundu",
          "other": "pśed {0} sekundami",
          "two": "pśed {0} sekundoma"
        }
      },
      "second-narrow": {
        "0": "něnto",
        "future": {
          "few": "za {0} s",
          "one": "za {0} s",
          "other": "za {0} s",
          "two": "za {0} s"
        },
        "past": {
          "few": "pśed {0} s",
          "one": "pśed {0} s",
          "other": "pśed {0} s",
          "two": "pśed {0} s"
        }
      },
      "second-short": {
        "0": "něnto",
        "future": {
          "few": "za {0} sek.",
          "one": "za {0} sek.",
          "other": "za {0} sek.",
          "two": "za {0} sek."
        },
        "past": {
          "few": "pśed {0} sek.",
          "one": "pśed {0} sek.",
          "other": "pśed {0} sek.",
          "two": "pśed {0} sek."
        }
      },
      "week": {
        "-1": "zajźony tyźeń",
        "0": "ten tyźeń",
        "1": "pśiducy tyźeń",
        "future": {
          "few": "za {0} tyźenje",
          "one": "za {0} tyźeń",
          "other": "za {0} tyźenjow",
          "two": "za {0} tyźenja"
        },
        "past": {
          "few": "pśed {0} tyźenjami",
          "one": "pśed {0} tyźenjom",
          "other": "pśed {0} tyźenjami",
          "two": "pśed {0} tyźenjoma"
        }
      },
      "week-narrow": {
        "-1": "zajź. tyźeń",
        "0": "te. tyźeń",
        "1": "pśid. tyźeń",
        "future": {
          "few": "za {0} tyź.",
          "one": "za {0} tyź.",
          "other": "za {0} tyź.",
          "two": "za {0} tyź."
        },
        "past": {
          "few": "pśed {0} tyź.",
          "one": "pśed {0} tyź.",
          "other": "pśed {0} tyź.",
          "two": "pśed {0} tyź."
        }
      },
      "week-short": {
        "-1": "zajź. tyźeń",
        "0": "tot. tyźeń",
        "1": "pśiduc. tyźeń",
        "future": {
          "few": "za {0} tyź.",
          "one": "za {0} tyź.",
          "other": "za {0} tyź.",
          "two": "za {0} tyź."
        },
        "past": {
          "few": "pśed {0} tyź.",
          "one": "pśed {0} tyź.",
          "other": "pśed {0} tyź.",
          "two": "pśed {0} tyź."
        }
      },
      "year": {
        "-1": "łoni",
        "0": "lětosa",
        "1": "znowa",
        "future": {
          "few": "za {0} lěta",
          "one": "za {0} lěto",
          "other": "za {0} lět",
          "two": "za {0} lěśe"
        },
        "past": {
          "few": "pśed {0} lětami",
          "one": "pśed {0} lětom",
          "other": "pśed {0} lětami",
          "two": "pśed {0} lětoma"
        }
      },
      "year-narrow": {
        "-1": "ło.",
        "0": "lět.",
        "1": "zno.",
        "future": {
          "few": "za {0} l.",
          "one": "za {0} l.",
          "other": "za {0} l.",
          "two": "za {0} l."
        },
        "past": {
          "few": "pśed {0} l.",
          "one": "pśed {0} l.",
          "other": "pśed {0} l.",
          "two": "pśed {0} l."
        }
      },
      "year-short": {
        "-1": "łon.",
        "0": "lěts.",
        "1": "znow.",
        "future": {
          "few": "za {0} l.",
          "one": "za {0} l.",
          "other": "za {0} l.",
          "two": "za {0} l."
        },
        "past": {
          "few": "pśed {0} l.",
          "one": "pśed {0} l.",
          "other": "pśed {0} l.",
          "two": "pśed {0} l."
        }
      }
    },
    "locale": "dsb"
  });
}